module.exports = __webpack_public_path__ + "img/title_community.966382ab.png";